module.exports = __webpack_public_path__ + "static/img/EditTitleNew.a772aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EditTitleNew.png
// module id = whhr
// module chunks = 3